import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/lectures";

export const BULK_UPLOAD_ENDPOINT = `${BASE}/bulk-upload`;

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function create(data) {
  return axios.post(BASE, data);
}

export function remove(id) {
  return axios.delete(`${BASE}/${id}`);
}

export function byTopic(topicId) {
  return axios.get(`${BASE}/by-topic/${topicId}`);
}

export function addItem(data) {
  return axios.post(`${BASE}/items`, data);
}

export function updateItem(itemId, data) {
  return axios.patch(`${BASE}/items/${itemId}`, data);
}

export function removeItem(itemId) {
  return axios.delete(`${BASE}/items/${itemId}`);
}
